
import React, { useState } from 'react';
import { Button, Input, message, Steps, theme } from 'antd';

import '../../build.css'
import Buildtable from '../Buildtable';



 const Sop8=() =>{
  const { token } = theme.useToken();
  const [current, setCurrent] = useState(0);
  const [inputValue, setInputValue] = useState(''); // State for the input value

  const next = () => {
    setCurrent(current + 1);
  };

  const prev = () => {
    setCurrent(current - 1);
  };

  const steps = [  
    
    {
      title: 'Introduction',
      content: <>
      <div   style={{marginTop:'2rem',}}>
      <Buildtable />
      <h6 id="profile">STATEMENT OF PURPOSE</h6>
      <p style={{ marginTop: "1rem" }}>
      In a scenario where you have a background in mechanical engineering and aspire to pursue a master's in Computer Science and Engineering (CSE) with a gap period during which you were inactive, addressing the gap becomes a crucial aspect of your Statement of Purpose (SOP). You should focus on explaining the reasons for the gap and how it contributed to your decision to pursue further education in CSE.
                </p>


                 <p> <strong>Addressing the Gap - Key Emphasis Section</strong> </p>
                 <p></p>
                <br></br>
                <h6>Introduction: </h6>
                <p>In the introduction, you want to grab the reader's attention by clearly stating the academic field you are passionate about. Rather than beginning with personal details, dive into the subject matter. Explain what aspects of this field interest you and why. This could include specific experiences, classes, or personal moments that sparked your interest. Convey your enthusiasm for the subject and provide a brief glimpse into what you hope to achieve within this domain.</p>
                <p>
                  <strong >Mistakes that need to be taken care of:</strong> 
                  <br></br>
                  <strong>Avoid Ambiguity:</strong> Clearly articulate why this field captures your interest. Vague statements may leave the reader unsure about your genuine passion.
                 <p> <strong>Steer Clear of Clichés:</strong>  Be original in expressing your interest. Avoid clichés that might make your introduction sound generic.</p>
                </p>
                <br></br>
                


                <hr></hr>
              
       
        </div></>,
    },
    {
      title: 'background',
      content: <>
  <div className='martop'  > <p>
                  <strong>Background:-</strong> 
                 
                
                </p>
                <p><strong>What to Include:</strong></p>
                <p><strong>Utilization of Gap Period:</strong></p>
                Discuss how you utilized the gap period productively. This could include self-learning initiatives, online courses, certifications, personal projects, or any relevant activities that demonstrate your commitment to personal and professional development.
               <p><strong>Relevance to CSE Goals: </strong>
                </p>
                <p>Emphasize how the activities during the gap period are relevant to your goals in pursuing a master's in CSE. Connect the skills or knowledge gained during this time to your aspirations in the field.</p>
                <h6> <strong>Demonstrate Growth and Reflection:</strong></h6>
                <p> Highlight any personal or professional growth during the gap period. Discuss how this reflective period influenced your decision to transition from mechanical engineering to CSE and how it aligns with your career objectives.</p>
               
               <p><strong>Commitment to Academic Pursuit:</strong>
                 Express your commitment to academic excellence and your eagerness to return to formal education. Clearly state how the master's program in CSE at [University] aligns with your goals and aspirations.</p>
                 <p>
          <strong>
          How to Pen It:

          </strong>{" "}</p>

          <p>Discuss how you utilized the gap period productively. Mention any self-learning initiatives, online courses, certifications, or personal projects that you undertook to stay engaged and develop your skills.</p>
          <p>Connect the activities during the gap period to your goals in pursuing a master's in CSE. Demonstrate how the skills or knowledge gained during this time are relevant to your aspirations in the field.</p>
          <p>Highlight any personal or professional growth during the gap period and how this reflective period influenced your decision to transition to CSE.</p>
          <p>Conclude by expressing your commitment to academic excellence and your eagerness to contribute to the academic community at [University]. Reiterate how the master's program in CSE is a pivotal step in achieving your goals.</p>
         

               <p>Example:</p> 
               <p>During the gap period in my academic journey, I took a reflective pause for personal reasons. However, this time was far from idle; it became a transformative period marked by self-discovery and skill development. I actively engaged in self-learning initiatives, pursuing online courses and certifications in computer science. This period allowed me to delve deeper into emerging technologies, programming languages, and advancements in the field. The skills acquired during this time, including [specific skills], not only reflect my dedication to continuous learning but also align seamlessly with my aspirations in Computer Science and Engineering. This reflective pause served as a catalyst for my decision to transition from mechanical engineering to CSE. The Master's program at [University] is the next logical step in this journey, providing the ideal environment for me to contribute my unique perspective and absorb cutting-edge knowledge in the dynamic field of computer science. I am eager to return to formal education, and this gap period has only reinforced my commitment to academic excellence and professional growth.</p>
               
                {/* <hr></hr> */}

                <hr></hr></div> </>,
    },
    {
        title: 'Course',
        content: <>  <div class="martop" role="alert">
  
        <p>
          <strong>Why this Course : </strong>
        </p>
         <p>Here, elaborate on why you are specifically interested in the course you are applying for. Discuss specific aspects of the curriculum that align with your academic and career goals. Go beyond a surface-level description; delve into the unique features, specializations, or projects that attracted you to this course.</p>
<p><strong>Mistakes that need to be taken care of:</strong></p>
<p>Avoid broad statements about the course. Dive into the specifics of the curriculum, mentioning particular courses or projects that resonate with your aspirations.</p>
<p><strong>Neglecting Skills Enhancement:</strong> Clearly explain how the course will enhance your skills and contribute to your professional development.</p>

        </div>
        </>,
      },
      {
        title: 'Goals',
        content: <>
        <div className='martop'></div>
          <p >
                    <strong>Career Goals : </strong>
                  </p>
                  <li>
                  Explanation: In this section, clearly outline your short-term and long-term career goals. Specify what you aim to achieve immediately after completing the course and paint a vivid picture of your aspirations for the next 10-15 years. Avoid mentioning a desire to stay in a foreign country for an extended period, as it can be perceived as a lack of commitment.
                  </li>
                <p><strong>Mistakes that need to be taken care of:</strong></p>
                <strong>Vagueness:</strong>
                <p>Clearly define your goals, providing details about the industry, role, or projects you aim to be involved in.</p>
                <p><strong>Contradictions: </strong>Ensure that your stated goals align with the course you are applying for. Consistency is crucial for credibility.</p>
        </>,
      },
      {
        title: 'Second',
        content: <>
      <p   style={{marginTop: '10px',}}><strong>Why this University:</strong> This section is your chance to show that you've done your homework on the university. Highlight specific features, resources, or faculty members that attract you. Explain how these elements align with your academic and career objectives. Convey a genuine interest in what the university offers beyond just a prestigious name.</p>
      <p><strong>Mistakes that need to be taken care of:</strong></p>
      <p><strong>Generic Praise: </strong>Avoid using generic statements about the university's reputation. Instead, focus on unique features that resonate with your goals.</p>
      <p><strong>Lack of Personalization:</strong>Ensure your reasons for choosing the university go beyond general information available on their website. Personalize your response to demonstrate a deep understanding.</p>
        Conclusion: Summarize the key points discussed in your Statement of Purpose. Reiterate your passion for the chosen field and emphasize how the course at the university is a crucial step toward achieving your goals. End on a strong note, leaving a lasting impression.
      <br></br>  <strong>Introducing New Information: </strong>The conclusion is not the place for new information. Stick to summarizing what you've already discussed.
        <br></br><strong>Lack of Confidence: </strong>  Convey confidence in your goals and how the chosen course at the university is integral to your success.
       <p><strong>Mistakes that need to be taken care of:</strong></p>    
       <p><strong>Introducing New Information: </strong>The conclusion is not the place for new information. Stick to summarizing what you've already discussed.</p>
       <p><strong>Lack of Confidence: </strong>Convey confidence in your goals and how the chosen course at the university is integral to your success.</p>
        </>,
      },
  ];

  const items = steps.map((item) => ({
    key: item.title,
    title: item.title,
  }));

  const contentStyle = {
    // lineHeight: '260px',
    // textAlign: 'center',
    // color: token.colorTextTertiary,
    // backgroundColor: token.colorFillAlter,
    // borderRadius: token.borderRadiusLG,
    // border: `1px dashed ${token.colorBorder}`,
    // marginTop: 16,
  };

  return (
    <>
      <Steps current={current} items={items} />
      <div style={contentStyle}>{steps[current].content}</div>
      <div
        style={{
          marginTop: 24,
        }}
      >
         {current > 0 && (
          <Button
            style={{
              margin: '0 8px',
            }}
            onClick={() => prev()}
          >
            Previous
          </Button>
        )}{current < steps.length - 1 && (
          <Button type="primary" onClick={() => next()}>
            Next
          </Button>
        )}
       
        {current === steps.length - 1 && (
          <Button type="primary" onClick={() => message.success(`Processing complete! Input: ${inputValue}`)}>
            Done
          </Button>
        )}
       
      </div>
    </>
  );
};

export default Sop8;
